import { type BlockId, type CustomFont, getCustomFontSize } from 'venn-state';
import {
  type RecoilState,
  type RecoilValueReadOnly,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
} from 'recoil';
import { FontSizeInput } from 'venn-components';
import React from 'react';

export const BlockFontSizeInput = ({
  blockId,
  stateName,
  range,
  state,
  defaultState,
  isReadOnly,
}: {
  blockId: BlockId;
  stateName: string;
  range: { min: number; max: number };
  state: (blockId: BlockId) => RecoilState<CustomFont>;
  defaultState: RecoilValueReadOnly<CustomFont>;
  isReadOnly?: boolean;
}) => {
  const [size, setSize] = useRecoilState(state(blockId));
  const resetSize = useResetRecoilState(state(blockId));
  const defaultSize = useRecoilValue(defaultState);

  const resetMessage = `Restore workspace default (${getCustomFontSize(defaultSize)})`;

  return (
    <FontSizeInput
      label={stateName}
      value={size.fontSizePt}
      onChange={(value) => setSize({ ...size, fontSizePt: value })}
      resetEnabled={size.fontSizePt !== defaultSize.fontSizePt}
      resetTooltip={resetMessage}
      onReset={resetSize}
      isReadOnly={isReadOnly}
      {...range}
    />
  );
};
